export default __webpack_public_path__ + "static/media/preview-placeholder.9e4447da.jpg";